export * from './MaterialFavoriteButton.types';
export { default as MaterialFavoriteButton } from './MaterialFavoriteButton';
